import React from 'react';
export const PopUpBox = ({ openPopUpBox, children, className, modalWidth }) => {
  return (
    <div
      className={`${className} modal custom-modal-doc-cato fade ${openPopUpBox ? 'show' : ''}`}
      aria-hidden={!openPopUpBox}
      tabIndex={-1}
      style={{ display: openPopUpBox ? 'block' : 'none' }}
    >
      <div className="modal-dialog p-0" style={modalWidth ? { width: modalWidth, maxWidth: modalWidth } : { width: '100%' }}>
        <div className="modal-content p-1 ">
          {/* <div className="d-flex m-1 mx-4"> */}
          <div>{children}</div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};
